import { IconName } from '@shinetools/sunshine-icons';
import { History } from 'history';
import { omit } from 'ramda';

export type OperationActionId =
  | 'activate'
  | 'unblock-pin'
  | 'update-pin'
  | 'stolen-confirm'
  | 'lost-confirm'
  | 'deactivate-confirm'
  | 'order-new-physical'
  | 'request-new-physical'
  | 'lock'
  | 'unlock-confirm'
  | 'lock-confirm';

export type CardActionDetails = {
  description: string;
  disabled?: boolean;
  iconName?: IconName;
  isDanger?: boolean;
  operationId: OperationActionId;
  previousOperationId?: OperationActionId;
  title: string;
};

export type CardActionProps = Omit<
  CardActionDetails,
  'operationId' | 'previousOperationId'
> & {
  onClick: () => void;
};

export function formatActionDetailsToActionCell(
  actions: CardActionDetails[],
  creditCardId: string,
  history: History,
): CardActionProps[] {
  return actions.map((action) =>
    omit(['operationId', 'previousOperationId'])({
      ...action,
      onClick: () =>
        history.push({
          pathname: `/cards/${creditCardId}/${action.operationId}`,
          state: { previousOperationId: action.previousOperationId },
        }),
    }),
  );
}
